<template>
  <div v-if="berechtigungen.m_lead.read">
    <div class="row pt-1">
      <div class="col-lg-12">
        <div class="tile-categorie-frame">
          <div class="tile-categorie">
            <div class="header">
              <span>{{ $t("dashboard.leadsbystage") }}</span>
            </div>
            <div class="body">
              <div class="row">
                <div class="col-xl-12">
                  <column-chart
                    :data="statistikLeadsByStage"
                    height="300px"
                    prefix="CHF"
                    thousands="'"
                    :colors="[
                      '#add58c',
                      '#1ad7e1',
                      '#ade0ec',
                      '#c3c4e2',
                      '#fccb9d',
                      '#f4f3d5',
                    ]"
                    :legend="false"
                  ></column-chart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/Api";

export default {
  name: "StartseiteLeads",
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      statistikLeadsByStage: null,
    };
  },
  created() {
    Api.get("/statistik/", { params: { type: "leadsbystage" } }).then(
      (response) => {
        let tempList = response.data;
        this.statistikLeadsByStage = [];
        let stages = {};

        tempList.forEach((item) => {
          if (!stages[item[0]]) stages[item[0]] = 0;

          stages[item[0]] += item[1];
        });

        this.statistikLeadsByStage = stages;
      }
    );
  },
  mounted() {},
  computed: {},
  methods: {},
};
</script>
